import { render, staticRenderFns } from "./CalendarMonthIcon.vue?vue&type=template&id=0c1c72f4&scoped=true&"
import script from "./CalendarMonthIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarMonthIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c72f4",
  null
  
)

export default component.exports